import React, { useState } from "react";
// import FileUpload from "./components/file-upload/file-upload.component";
import FileUpload from "../file-upload/file-upload.component";

// import { AnimateCC, GetAnimationObjectParameter } from "react-adobe-animate";

const AddFile = () => {
  const [newUserInfo, setNewUserInfo] = useState({
    profileImages: []
  });

  const updateUploadedFiles = (files) =>
    setNewUserInfo({ ...newUserInfo, profileImages: files });

  const handleSubmit = (event) => {
    event.preventDefault();
    //logic to create new user...
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FileUpload
          accept=".jpg,.png,.jpeg,.gif"
          label="Profile Image(s)"
          multiple
          updateFilesCb={updateUploadedFiles}
        />
        <button type="submit">Create New User</button>
      </form>
    </div>
  );


};

export default AddFile;
